const PRODUCT_EVENT = {
  updatedVariant: 'maximize:variant-picker:updated:',
  swatchChange: "maximize:color-swatch:change:",
  giftCardRecipientChange: "maximize:gift-card-recipient:change:",
  productRecommendationsChange: "maximize:product-recommendations:change:"
};

const STICKY_ATC_EVENT = {
  optionChange: 'maximize:sticky-atc:option:updated:'
};

const CART_EVENT = {
  cartUpdate: 'maximize:cart:updated',
  validate: 'maximize:cart:validate',
  discountCodeChange: 'maximize:cart:discount-code:change',
  showCustomFiled: "maximize:cart:show-custom-field"
};

const STORE_MAP_EVENT = {
  openPopup: 'maximize:store-map:open'
};

const SELECT_ELEMENT_EVENT = {
  updated: 'maximize:select-element:updated',
  change: 'maximize:select-element:change'
}

const SWIFFY_SLIDER_EVENT = {
  slide: 'maximize:swiffy-slider:slide'
}

const ANIMATION_EVENT = {
  revealItem: 'maximize:animation:reveal'
}

const FACET = {
  productLayout: 'facet-product-layout'
}
const CART_ATTRIBUTES = {
  product_comparison_options :'product_comparison_variant_options',
  product_comparison_metafields: 'product_comparison_metafields'
}

const MIN_DEVICE_WIDTH = {
  desktop: 1024,
  tablet: 768
}

const PREORDER_TYPE_SHOW = {
  yes: 'yes',
  onBackOrder: 'on_back_ordered'
}

const LOCAL_STORAGE = {
  maximize_cart_custom_field: 'maximize_cart_custom_field',
  quick_help_popup_closed_in_version: 'quick_help_popup_closed_in_version'
}

const ZOOM_EFFECT = {
  enlarge: 'enlarge',
  magnifier:'magnifier'
}

const PRODUCT_FORM_SOURCE_CHANGE = {
  variantPicker: 'variant-picker',
  giftCardRecipient: 'gift-card-recipient'
}

const PRODUCT_BUNDLE = {
  productChange: 'maximize:product-bundle:products-changed:',
  addToBundle: 'maximize:product-bundle:add-to-bundle:'
}
const ADDITIONAL_FEE = {
  defaultTextDropDown: '-----'
}
const TIMEOUT = {
  scrollIdle: 100
}

const THRESHOLD = {
  startScroll: 10
}
